import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { List } from "immutable";
import * as React from "react";
import { Jumbo } from "../../components/jumbo";
import { Teasers } from "../../components/teaser";
import { initialNewsResponse, resultsClass } from "./newsOverviewState";
import { Pager } from "../../../../Shared/components/Pager";
export const NewsOverviewLayout = (props)=>{
    const { headerTitle, description, phImageUrl, phImageUrlFallback, phImageUrlLarge, imageAlt, newsLoader, currentPage, pageSize, setPage, key } = props;
    const { news, totalResults } = newsLoader.kind == 'loaded' || newsLoader.kind == 'loading' ? newsLoader.value : initialNewsResponse;
    const pager = totalResults ? Pager({
        currentPage,
        pageSize,
        totalResults,
        setPage
    }) : /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Jumbo, {
                title: headerTitle,
                contents: description,
                imageUrl: phImageUrl,
                imageUrlFallback: phImageUrlFallback,
                imageUrlLarge: phImageUrlLarge,
                imageAlt: imageAlt,
                size: "small"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "container--lg align--center",
                children: /*#__PURE__*/ _jsx("section", {
                    className: resultsClass,
                    children: news.length > 0 ? /*#__PURE__*/ _jsx(Teasers, {
                        items: List(news)
                    }) : /*#__PURE__*/ _jsx(NoNews, {})
                })
            }),
            pager
        ]
    }, key);
};
const NoNews = ()=>/*#__PURE__*/ _jsx("div", {
        className: "text--styled",
        children: /*#__PURE__*/ _jsx("p", {
            className: "weight--bold container--s",
            children: "Op dit moment zijn er helaas geen nieuwsberichten beschikbaar."
        })
    });
